import { render, staticRenderFns } from "./DemandInfo.vue?vue&type=template&id=06135ff7&scoped=true"
import script from "./DemandInfo.vue?vue&type=script&lang=js"
export * from "./DemandInfo.vue?vue&type=script&lang=js"
import style0 from "./DemandInfo.vue?vue&type=style&index=0&id=06135ff7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06135ff7",
  null
  
)

export default component.exports